import request from '@/apis/request'
const resource = 'users/me'

export default {
  getUserProfile: () => {
    return request.get(`${resource}`)
  },

  updateProfile: (data) => {
    return request.put(`${resource}`, data)
  },

  updateProfileFormData: (data) => {

    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    }

    return request.post(`${resource}`, data, options)
  },

  updateChangePassword: (data) => {
    return request.put(`${resource}/change-password`, data)
  },

  getDemoUserVerify: () => {
    return request.get(`demo-users/verify`)
  },
}